// src/utils/api-helpers/UsersServiceExtended.helpers.ts
// Small helper to fetch current user permissions
import { UsersService } from '../../api';

export class UsersServiceExtendedHelpers {
  static async getMyPermissions(): Promise<string[]> {
    const resp = await UsersService.usersControllerGetMyPermissions();
    if (!resp) return [];
    if (Array.isArray((resp as any).permissions)) {
      return (resp as any).permissions;
    }
    if (Array.isArray(resp)) return resp as any;
    return [];
  }
}
